import Cookies from 'js-cookie';

const rolexConsentCookieName = 'rlx-consent';

const rolexConsentGranted = () => Cookies.get(rolexConsentCookieName) === 'true';

const setRolexConsent = (value) => {
  Cookies.set(rolexConsentCookieName, value, { expires: 365 });
};

export {
  rolexConsentGranted,
  setRolexConsent,
};
